'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.29 12.074c.163 0 .298.116.33.269l.006.067v8.253a.337.337 0 0 1-.268.33l-.067.007H5.488v-.673h3.609v-3.613h.673v3.613h11.184v-7.58h-7.213v-.673h7.55Zm-5.592 1.346v6.234h-.673V13.42h.673Zm-6.44-1.345v.673H3.78v5.479h-.673V12.41c0-.186.15-.336.336-.336h5.815Zm7.45 4.024a.336.336 0 1 1 0 .672.336.336 0 0 1 0-.672Zm-2.691 0a.336.336 0 1 1 0 .672.336.336 0 0 1 0-.672Zm-7.333-1.45v.673H4.83v-.673h1.854Zm1.026-1.345a.336.336 0 1 1 0 .672.336.336 0 0 1 0-.672Zm-1.271 0a.336.336 0 1 1 0 .672.336.336 0 0 1 0-.672Zm-1.272 0a.336.336 0 1 1 0 .672.336.336 0 0 1 0-.672Zm13.15-10.288v.673h-6.272v4.844h.755v.673h-1.092a.337.337 0 0 1-.336-.336V3.353c0-.186.151-.337.336-.337h6.609Zm3.31 1.844v4.01c0 .185-.15.336-.336.336h-4.01v-.673h3.674V4.86h.672ZM7.255 3.016c.185 0 .336.151.336.337v1.595l1.6 1.65h1.171c.186 0 .337.15.337.335V8.87a.337.337 0 0 1-.337.337H2.514a.337.337 0 0 1-.337-.337V6.933c0-.185.151-.336.337-.336h1.171l1.6-1.649V3.353c0-.186.151-.337.336-.337Zm-.143 2.405H5.764L4.622 6.597h1.816v.673H2.85v1.263h7.176V7.27H7.447v-.673h.806l-1.14-1.176Zm8.371.252a.336.336 0 1 1 0 .673.336.336 0 0 1 0-.673ZM6.918 3.69h-.96v1.06h.96v-1.06Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.772 3H21.6c.2 0 .3.241.159.382L4.212 20.93a.223.223 0 0 1-.158.065h-1.83a.224.224 0 0 1-.158-.382L19.613 3.066A.228.228 0 0 1 19.772 3",
    fill: "currentColor"
  })));
});
var FwSet0KitchenNo = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0KitchenNo = FwSet0KitchenNo;